/**
 * Shared sequence digit padding for SKUs and invoice numbers.
 * 1–999 → 3 digits (001…999); 1000–9999 → 4 digits (1000…9999).
 * @param {number} n
 * @returns {string}
 */
export function formatSequenceDigits(n) {
  const num = Math.floor(Number(n));
  if (!Number.isFinite(num) || num < 1) return '001';
  if (num <= 999) return String(num).padStart(3, '0');
  if (num <= 9999) return String(num).padStart(4, '0');
  return String(num);
}
